import { safeDefine } from "../../registration/safe-define.js";
import { TooltipShortcutElement } from "../../ui/tooltip/shortcut.js";
//#region src/define/ui/tooltip-shortcut.ts
safeDefine(TooltipShortcutElement);
//#endregion

//# sourceMappingURL=tooltip-shortcut.js.map